export class JsonStringHelper {

    static FormatString(text: string) {

        try {
            var description = JSON.stringify(JSON.parse(text), null, "\t");
            // plain text only: callers render it as text, so escaped newlines become real ones (no <br /> markup)
            description = description.replace(/\\n/g, "\n").replace(/\\r/g, "")
            description = this.unicodeToChar(description || "")
            return description
        } catch (e) {
            return text;
        }

    }

    static unicodeToChar(text: string) {
        return text.replaceAll(/\\u[\dA-F]{4}/g,
            (match) => {
                const hex = match.replace(/\\u/g, '');
                const decimal = parseInt(hex, 16)
                return String.fromCharCode(decimal);;
            });
    }

}